export default {
  itens(state) {
    return state.itens;
  },
  selects(state) {
    return state.selects;
  },
  ano(state) {
    return state.ano;
  },
  orcamento(state) {
    return state.orcamento;
  }
};
